import { render } from "./renwuList.vue?vue&type=template&id=5ddf370e&scoped=true"
import script from "./renwuList.vue?vue&type=script&lang=js"
export * from "./renwuList.vue?vue&type=script&lang=js"

import "./renwuList.vue?vue&type=style&index=0&id=5ddf370e&scoped=true&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddf370e"]])

export default __exports__